const program = {
  getActiveProgram: null,
  getActiveProgramWithAssociate: null,
  getProgramById: null,
};

export default program;
